export interface IPopupErrorModel {
    errorType: ErrorTypes;
    customErrorText: string;
}

export enum ErrorTypes {
    NONE,
    GENERAL,
    TIMEOUT
}

